import $ from 'jquery';

export default ($carousel) => {
  let all_slides_visible = true;
  const initial_offset_top = $carousel.children().eq(0).offset().top;

  $carousel.children().each((index, slide) => {
    if ($(slide).offset().top !== initial_offset_top) {
      all_slides_visible = false;
    }
  });

  return all_slides_visible;
};